import type { UserManagementDto } from '@hisense/shared';
export function filterUsers(rows:UserManagementDto[],q:string,role:string,status:string,sort:string){
 const search=q.trim().toLocaleLowerCase();
 return rows.filter(u=>(!role||u.role===role)&&(!status||u.status===status)&&(!search||`${u.displayName} ${u.email}`.toLocaleLowerCase().includes(search))).sort((a,b)=>{
  if(sort==='name')return a.displayName.localeCompare(b.displayName)||a.email.localeCompare(b.email);
  if(sort==='email')return a.email.localeCompare(b.email);
  if(sort==='lastLogin')return (b.lastLoginAt??-1)-(a.lastLoginAt??-1)||a.email.localeCompare(b.email);
  return b.createdAt-a.createdAt||a.email.localeCompare(b.email);
 });
}
